import { render, staticRenderFns } from "./ExamViolation.vue?vue&type=template&id=791aea55&scoped=true"
import script from "./ExamViolation.vue?vue&type=script&lang=js"
export * from "./ExamViolation.vue?vue&type=script&lang=js"
import style0 from "./ExamViolation.vue?vue&type=style&index=0&id=791aea55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791aea55",
  null
  
)

export default component.exports